import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDetailModel } from 'countable@model';
import { DraggedFileModel } from '../../model/file/drag/dragged-file.model';
import { DropMiddleRequestModel } from '../../model/file/drag/drop-middle-request.model';
import { ResponseItemModel } from '../../model/file/drag/responce/response-item.model';
import { ResponseModel } from '../../model/file/drag/responce/response.model';
import { SourceElementModel } from '../../model/file/drag/source-element.model';
import { FileReferenceModel } from '../../model/file/file-reference.model';
import { LoginUserModel } from '../../model/login-user.model';
import { ApiService } from '../../services/api.service';
import { ModuleInfo } from '../../services/app-config';
import { GenericServerResponseHandlerService } from '../../services/generic-server-response-handler.service';
import { SharedService } from './shared.service';

class ModuleSpecificParam {
  refPkId: number;
  finSubGroupId = 0;
  finSubGroupName: string = null;
  subModuleId: number;
  moduleId: number;
  destinationDirectory: string;
  selectedEngagement: any;
  user: UserDetailModel;
}

@Injectable({providedIn: 'root'})
export class DragAndDropService {

  constructor(private apiService: ApiService,
              private serverResponseHandler: GenericServerResponseHandlerService, private shareService: SharedService) {
  }

  public static getModuleSpecificParam(sourceElement: SourceElementModel, moduleId: number,
                                       selectedEngagement: any, user: UserDetailModel): ModuleSpecificParam {
    const moduleSpecificParam = new ModuleSpecificParam();
    moduleSpecificParam.moduleId = moduleId;
    moduleSpecificParam.destinationDirectory = ModuleInfo.getS3DestinationDirectory(moduleId);
    moduleSpecificParam.selectedEngagement = selectedEngagement;
    moduleSpecificParam.user = user;

    switch (moduleId) {
      case ModuleInfo.MODULE_PROCEDURE:
        moduleSpecificParam.refPkId = sourceElement.trailbalanceid;
        moduleSpecificParam.finSubGroupId = sourceElement.finsubgroupid;
        moduleSpecificParam.subModuleId = sourceElement.submoduleid;
        moduleSpecificParam.finSubGroupName = sourceElement.finsubgroupname;
        break;
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_ACCEPTANCE:
        moduleSpecificParam.refPkId = sourceElement.clientquestionid;
        moduleSpecificParam.finSubGroupId = 0;
        moduleSpecificParam.subModuleId = 2;
        break;
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_PLANNING:
        moduleSpecificParam.refPkId = sourceElement.clientquestionid;
        moduleSpecificParam.finSubGroupId = 0;
        moduleSpecificParam.subModuleId = 5;
        break;
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_INDEPENDENCE:
        moduleSpecificParam.subModuleId = 3;
        moduleSpecificParam.refPkId = sourceElement.clientquestionid;
      case ModuleInfo.MODULE_WORKSHEETS:
        moduleSpecificParam.subModuleId = 913;
        break;
    }

    return moduleSpecificParam;
  }

  private static getDroppedFiles(event: CdkDragDrop<DraggedFileModel, any>,draggedFileClientDocId : (number | null)): DraggedFileModel {
    if (event.previousContainer.data && event.previousContainer.data.length > 0) {
      const draggedFileIndex = event.previousContainer.data.findIndex(doc => {
        return doc.engteamclientdocid === draggedFileClientDocId
      });
      if(draggedFileIndex === event.previousIndex) {
        return event.previousContainer.data[event.previousIndex];
      } else {
        return draggedFileIndex !== -1 ? event.previousContainer.data[draggedFileIndex] : event.previousContainer.data[event.previousIndex];
      }
    }
  }

  public handleDropToMiddleES(event: CdkDragDrop<DraggedFileModel, any>, sourceElement: SourceElementModel,
                              moduleSpecificParam: ModuleSpecificParam, draggedFileClientDocId?: (number | null)) {
    return DragAndDropService.getDroppedFiles(event, draggedFileClientDocId);
  }

  async handleDropToTheMiddle(event: CdkDragDrop<DraggedFileModel, any>, sourceElement: SourceElementModel,
                              moduleSpecificParam: ModuleSpecificParam , draggedFileClientDocId? : (number | null)): Promise<ResponseModel> {

    const droppedFiles: DropMiddleRequestModel[] = [];
    const draggedFile = DragAndDropService.getDroppedFiles(event,draggedFileClientDocId);
    const dropMiddleRequest = new DropMiddleRequestModel();
    dropMiddleRequest.date = draggedFile.date;
    dropMiddleRequest.time = draggedFile.time;
    dropMiddleRequest.firmId = moduleSpecificParam.user.firmUserAcctId;
    dropMiddleRequest.clientId = moduleSpecificParam.selectedEngagement.clientfirmid;
    dropMiddleRequest.engagementId = moduleSpecificParam.selectedEngagement.engagementsid;
    dropMiddleRequest.engTeamClientDocId = draggedFile.engteamclientdocid;
    dropMiddleRequest.userFullName = draggedFile.fullname;
    dropMiddleRequest.isRead = draggedFile.isread;
    dropMiddleRequest.isnewcopy = 0;

    dropMiddleRequest.sourceFileExtensionPath = draggedFile.extensionspath;
    dropMiddleRequest.sourceFileExtension = draggedFile.extension;
    dropMiddleRequest.sourceFilename = draggedFile.filename;
    dropMiddleRequest.sourceFileNameChange = draggedFile.filenamechange;
    dropMiddleRequest.sourceFilePath = draggedFile.filepath;
    dropMiddleRequest.sourceFileMsSdkId = draggedFile.mssdkfileid;
    dropMiddleRequest.sourceFileOriginalFileName = draggedFile.originalfilename;
    dropMiddleRequest.sourcePartnerFolderFileId = draggedFile.partnerfolderfileid;
    dropMiddleRequest.sourcePartnerFolderId = draggedFile.partnerfolderid;
    dropMiddleRequest.sourceFileNameWithoutExtension = draggedFile.withoutextension;
    dropMiddleRequest.sourceFileDirectory = draggedFile.filepath.slice(0, draggedFile.filepath.lastIndexOf('/'));

    dropMiddleRequest.destinationModule = moduleSpecificParam.moduleId;
    dropMiddleRequest.destinationRefPkId = moduleSpecificParam.refPkId;
    dropMiddleRequest.destinationSubModuleId = moduleSpecificParam.subModuleId;
    dropMiddleRequest.destinationFinSubGroupId = moduleSpecificParam.finSubGroupId;
    dropMiddleRequest.destinationFinSubGroupName = moduleSpecificParam.finSubGroupName;
    dropMiddleRequest.destinationLeadSheetId = sourceElement.leadsheetid;
    dropMiddleRequest.destinationLeadSheetName = sourceElement.leadsheetname;
    dropMiddleRequest.destinationDirectory = moduleSpecificParam.destinationDirectory;
    droppedFiles.push(dropMiddleRequest);
    return await this.callServer(droppedFiles);
  }

  refreshCountable(event: CdkDragDrop<DraggedFileModel>, sourceElement: SourceElementModel,
                   responseItem: ResponseItemModel, moduleSpecificParam: ModuleSpecificParam) {
    // When it reaches here, means each component load their specific data again
    this.shareService.docReferencedSuccessfully.next('success');
    this.shareService.refreshAllleftsidedocs.next('refresh');
    // finally, update whatever each component needs
    switch (moduleSpecificParam.moduleId) {
      case ModuleInfo.MODULE_PROCEDURE:
        this.refreshProcedure(responseItem, sourceElement, event);
        break;
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_INDEPENDENCE:
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_ACCEPTANCE:
      case ModuleInfo.MODULE_CLIENT_ON_BOARDING_PLANNING:
        this.refreshClientDocListDetail(responseItem, moduleSpecificParam);
        break;
      case ModuleInfo.MODULE_WORKSHEETS:
        this.refreshES(responseItem, sourceElement, event);
        break;
    }
  }

  showToasterForResponse(responseItem: ResponseItemModel) {
    this.serverResponseHandler.handle(responseItem);
  }

  private refreshProcedure(responseItem: ResponseItemModel, sourceElement: SourceElementModel, event: CdkDragDrop<DraggedFileModel>) {
    if (sourceElement) {
      // Update references list
      event.previousContainer.data[event.previousIndex].referenceCount++;
      // Add the reference to the list of references
      if (!sourceElement.Referenc) {
        sourceElement.Referenc = [];
      }
      const fileReference = new FileReferenceModel();
      fileReference.REF = ''; // SP does not return this, so we need to fill it until our next request to server!
      fileReference.engleftsidedocid = responseItem.engLeftSideDocId;
      fileReference.engteamclientdocid = responseItem.engTeamClientDocId;
      fileReference.extension = responseItem.extension;
      fileReference.extensionspath = responseItem.extensionPath;
      fileReference.filename = responseItem.fileName;
      fileReference.filepath = responseItem.filePath;
      fileReference.mssdkfileid = responseItem.fileHashId;
      fileReference.submoduleid = sourceElement.submoduleid;
      fileReference.fileNameWithoutExt = responseItem.fileName.slice(0, responseItem.fileName.indexOf('.'));
      sourceElement.Referenc.push(fileReference);
    }

    // added for duplicate lead sheet
    const procedureDetails = JSON.parse((localStorage.getItem('procedureDetails')));
    this.shareService.isDocReference.next({
      fingroupid: procedureDetails.fingroupid,
      fingroupname: procedureDetails.fingroupname,
      finsubgroupid: procedureDetails.finsubgroupid,
      leadsheetid: procedureDetails.leadsheetId,
      leadsheetcode: procedureDetails.leadsheetcode,
      finsubgroupname: procedureDetails.finsubgroupname, // added for duplicate lead sheet
      referenceDoc: responseItem.fileName, // sending value in procedure section
      engteamclientdocid: responseItem.engTeamClientDocId, // sending value in procedure section
      filename: responseItem.originalFileName,
      filePath: responseItem.filePath
    }); // pushing response in NTR dashboard comp. procedure section
  }
  private refreshES(responseItem: ResponseItemModel, sourceElement: SourceElementModel, event: CdkDragDrop<DraggedFileModel>) {
    if (sourceElement) {
      // Update references list
      event.previousContainer.data[event.previousIndex].referenceCount++;
      // Add the reference to the list of references
      if (!sourceElement.Referenc) {
        sourceElement.Referenc = [];
      }
      const fileReference = new FileReferenceModel();
      fileReference.REF = ''; // SP does not return this, so we need to fill it until our next request to server!
      fileReference.engleftsidedocid = responseItem.engLeftSideDocId;
      fileReference.engteamclientdocid = responseItem.engTeamClientDocId;
      fileReference.extension = responseItem.extension;
      fileReference.extensionspath = responseItem.extensionPath;
      fileReference.filename = responseItem.fileName;
      fileReference.filepath = responseItem.filePath;
      fileReference.mssdkfileid = responseItem.fileHashId;
      fileReference.submoduleid = sourceElement.submoduleid;
      fileReference.fileNameWithoutExt = responseItem.fileName.slice(0, responseItem.fileName.indexOf('.'));
      sourceElement.Referenc.push(fileReference);
    }
    this.shareService.isDocReference.next({
      // fingroupid: procedureDetails.fingroupid,
      // fingroupname: procedureDetails.fingroupname,
      // finsubgroupid: procedureDetails.finsubgroupid,
      // leadsheetid: procedureDetails.leadsheetId,
      // leadsheetcode: procedureDetails.leadsheetcode,
      // finsubgroupname: procedureDetails.finsubgroupname, // added for duplicate lead sheet
      referenceDoc: responseItem.fileName, // sending value in procedure section
      engteamclientdocid: responseItem.engTeamClientDocId, // sending value in procedure section
      filename: responseItem.originalFileName,
      filePath: responseItem.filePath,
      mssdkfileid:responseItem.mssdkfileid
    });
  }

  private async callServer(droppedFiles: DropMiddleRequestModel[]) {
    return new Promise<ResponseModel>((resolve, reject) => {
      this.apiService.createReferenceInTheMiddle(droppedFiles).then(
        (data) => {
          resolve(data);
        },
        (error: HttpErrorResponse) => {
          reject(this.handleError(error));
        });
    });
  }

  private handleError(error: HttpErrorResponse): ResponseItemModel {
    const responseItem = new ResponseItemModel();
    responseItem.resultCode = 'error';

    if (error.status === 0) { // A client-side or network error occurred. Handle it accordingly.
      responseItem.message = 'Could not communicate to server! Please check you Internet!';
    } else { // The backend returned an unsuccessful response code. The response body may contain clues as to what went wrong.
      responseItem.message = 'Processing Error';
    }
    this.showToasterForResponse(responseItem);
    return responseItem;
  }

  private refreshClientDocListDetail(responseItem: ResponseItemModel, moduleSpecificParam: ModuleSpecificParam) {
    this.shareService.clientAcceptanceDocDetails.next({
      ...responseItem,
      submoduleid: moduleSpecificParam.subModuleId
    });
  }
}
